import BaseButton from './button';
import Accent from './accent';
import Cancel from './cancel';
import Danger from './danger';
import Primary from './primary';
import Secondary from './secondary';
import Success from './success';

const Button = Object.assign(BaseButton, {
  Accent,
  Cancel,
  Danger,
  Primary,
  Secondary,
  Success,
});

export default Button;
